import http from "../../services/http";

const getAllCollaboratorsApi = async (form_id) => {
  return await http("get", `v1/formularios_colaboradores/perfil/getAll/${form_id}`);
};

const createProfileApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/perfil/create", data);
};

export { createProfileApi, getAllCollaboratorsApi };
